export function normName(s) {
  return String(s || "").toLowerCase().replace(/[^a-z0-9 ]/g, "").replace(/\s+/g, " ").trim();
}

export function lev(a, b) {
  const m = a.length, n = b.length;
  if (!m) return n; if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, i) => i);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    prev = cur;
  }
  return prev[n];
}

export function likelyDuplicate(a, b) {
  const na = normName(a), nb = normName(b);
  if (!na || !nb || na === nb) return na === nb;
  const ta = na.split(" "), tb = nb.split(" ");
  const lastA = ta[ta.length - 1], lastB = tb[tb.length - 1];
  if (lastA === lastB && lastA.length > 1) {
    const fa = ta[0], fb = tb[0];
    if (fa === fb) return true;
    if (fa && fb && (fa.startsWith(fb) || fb.startsWith(fa))) return true;
  }
  const maxLen = Math.max(na.length, nb.length);
  if (maxLen >= 5 && lev(na, nb) <= 2) return true;
  return false;
}

export function findDuplicatePairs(names, cap = 8) {
  const pairs = [];
  for (let i = 0; i < names.length; i++) {
    for (let j = i + 1; j < names.length; j++) {
      if (likelyDuplicate(names[i].name, names[j].name)) pairs.push([names[i], names[j]]);
      if (pairs.length >= cap) return pairs;
    }
  }
  return pairs;
}

export function namesFromResults(results) {
  const m = {};
  (results || []).forEach((r) => { if (r.player_name) m[r.player_name] = (m[r.player_name] || 0) + 1; });
  return Object.entries(m).map(([name, count]) => ({ name, count }));
}
